import { useMutation, useQueryClient } from 'react-query';
import { enqueueSnackbar } from 'notistack';

import { updateProfile } from 'api/profile/updateProfile';

export const useUpdateProfile = () => {
  const queryClient = useQueryClient();

  const {
    isSuccess,
    mutate: updateProfileMutation,
    isLoading,
  } = useMutation(updateProfile, {
    onSuccess: () => {
      enqueueSnackbar('Profile updated successfully', {
        variant: 'success',
      });
      // Invalidate and refetch profile data
      queryClient.invalidateQueries('profile');
    },
    onError: (error: any) => {
      console.error('Profile update error:', error);
      enqueueSnackbar(error.response?.data?.message || 'Failed to update profile', { variant: 'error' });
    },
  });

  return {
    isSuccess,
    updateProfileMutation,
    isLoading,
  };
};
